import {Comparateurs} from './ComparateurCritère.js';
import {Cibles} from "./Cibles.js";
import {OptionRecherche} from "./OptionRecherche.js";

export class CritèreRecherche {
    cible;
    comparateur = Comparateurs.ÉGALE;
    valeurs = [];

    constructor(cible, comparateur, valeurs) {
        this.cible = cible;
        this.comparateur = comparateur || Comparateurs.ÉGALE;
        this.valeurs = valeurs || [];
    }

    static asTexte(critère) {
        return critère.cible;
    }

    static asDiv(critère, abrégé) {

        const cible = Cibles[critère.cible];
        const comparateur = Comparateurs[critère.comparateur];

        let comparateurJoker = undefined;
        switch (critère.comparateur) {
            case Comparateurs.COMMENCE_PAR.code :
            case Comparateurs.NE_COMMENCE_PAS_PAR.code :
                comparateurJoker = Comparateurs.COMMENCE_PAR.code;
                break;
            case Comparateurs.SE_TERMINE_PAR.code :
            case Comparateurs.NE_SE_TERMINE_PAS_PAR.code :
                comparateurJoker = Comparateurs.SE_TERMINE_PAR.code
                break;
            case Comparateurs.CONTIENT.code :
            case Comparateurs.NE_CONTIENT_PAS.code :
                comparateurJoker = Comparateurs.CONTIENT.code;
                break;
        }

        const divÉlément = document.createElement("div");
        divÉlément.classList.add("recherche-critère");

        let valeurs = this.getValeurs(critère, cible);

        divÉlément.appendChild(this.getDivCritèreNom(cible));
        divÉlément.appendChild(this.getDivCritèreComparateur(comparateur, valeurs, abrégé));
        divÉlément.appendChild(this.getDivCritèreValeurs(valeurs, comparateurJoker));


        return divÉlément;
    }

    static getDivCritèreComparateur(comparateur, valeurs, abrégé) {
        const divComparateurÉlément = document.createElement("div");
        divComparateurÉlément.classList.add("recherche-critère-comparateur", "comparateur-" + comparateur.code.toLowerCase());
        if (abrégé) {
            const valeursMultiples = CritèreRecherche.isValeursMultiples(valeurs);
            if(valeursMultiples) {
                if(comparateur.négation) {
                    divComparateurÉlément.innerText = Comparateurs.N_EST_PAS_PARMI.abréviation;
                }
                else
                {
                    divComparateurÉlément.innerText = Comparateurs.EST_PARMI.abréviation;
                }
            }
            else {
                // divComparateurÉlément.innerText = comparateur.abréviation;
                if(comparateur.négation) {
                    divComparateurÉlément.innerText = Comparateurs.EST_DIFFÉRENT.abréviation;
                }
                else
                {
                    divComparateurÉlément.innerText = Comparateurs.ÉGALE.abréviation;
                }
            }
            divComparateurÉlément.classList.add("abrégé");
        } else {
            divComparateurÉlément.innerText = comparateur.nom;
        }
        return divComparateurÉlément;
    }

    static getDivCritèreNom(cible) {
        const divNomÉlément = document.createElement("div");
        divNomÉlément.classList.add("recherche-critère-nom");
        divNomÉlément.innerText = cible.nom;
        return divNomÉlément;
    }

    static getDivCritèreValeurs(valeurs, comparateurJoker) {

        const divValeursÉlément = document.createElement("div");
        divValeursÉlément.classList.add("recherche-critère-valeurs");

        const affixes = CritèreRecherche.getValeurAffixes(comparateurJoker);

        let chaîneValeurs = valeurs.join(", ");

        if (CritèreRecherche.isValeursMultiples(valeurs)) {
            divValeursÉlément.innerText = "{ " +
                chaîneValeurs.split(",").map((v) => { return CritèreRecherche.ajouteAffixes(v, affixes); }).join(", ")
                + " }";
        } else {
            divValeursÉlément.innerText = CritèreRecherche.ajouteAffixes(chaîneValeurs, affixes);
        }

        return divValeursÉlément;

    }

    static getValeurs(critère, cible) {
        let valeurs = [];

        critère.valeurs.forEach((critèreValeurs) => {
            if (cible.valeursPossibles.size > 0) {
                // Dans ce cas-ci critères.valeurs est un tableau à un seul élément avec les valeurs séparées par des virgules
                const cléParValeurTableau = CritèreRecherche.getCléParValeurTableau(cible.valeursPossibles, critèreValeurs.split(","));
                if (cléParValeurTableau) {
                    valeurs.push(cléParValeurTableau);
                }
            } else {
                valeurs.push(critèreValeurs);
            }
        })
        return valeurs;
    }

    static isValeursMultiples(valeurs) {
        let chaîneValeurs = valeurs.join(", ");
        return (valeurs.length > 1 || chaîneValeurs.indexOf(",") !== -1)
    }

    static ajouteAffixes(valeur, affixes) {
        return affixes.préfixe + valeur + affixes.suffixe;
    }

    static getValeurAffixes(comparateurJoker) {

        let préfixe = "";
        let suffixe = "";

        switch (comparateurJoker) {
            case Comparateurs.COMMENCE_PAR.code:
                suffixe = "...";
                break;
            case Comparateurs.SE_TERMINE_PAR.code:
                préfixe = "...";
                break;
            case Comparateurs.CONTIENT.code:
                préfixe = "...";
                suffixe = "...";
                break;
        }
        return {préfixe: préfixe, suffixe: suffixe};
    }

    static getCléParValeurTableau(map, tableau) {
        for (let [clé, valeurTableau] of map.entries()) {
            if (tableau.length === valeurTableau.length && valeurTableau.every((v, i) => v === tableau[i]))
                return clé;
        }
    }

    static getNomFiltre(options) {

        let nom;

        let lemmeSeulement = options.get(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code).valeur === "oui";
        let inclureVerbesConjugués = options.get(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code).valeur === "oui";

        if(lemmeSeulement) {
            nom = OptionRecherche.FILTRE_LEMMES_SEULEMENT.nom;
        }
        else if(inclureVerbesConjugués) {
            nom = OptionRecherche.FILTRE_TOUTES_LES_FORMES.nom;
        }
        else {
            nom = OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.nom;
        }

        return nom;

    }

}
